import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Search from '@ifeng-fe/ui_pc_search';
import { formatUrl } from '@ifeng-fe/public_method';
import Ad from '@ifeng-fe/ui_pc_ad';
import styles from './index.css';
import { classnames } from '../../../utils/classnames';

class Logo extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    // logo 图片 alt：补充品牌词，与页面 title（栏目_凤凰网）语义一致
    getLogoAlt(title) {
        if (!title) return '凤凰网';
        if (title.includes('凤凰网')) return title;
        return `凤凰网${title}`;
    }

    // 显示logo还是title；isH1 为当前页面主标题时包裹 h1
    displayLogoOrTitleView(item, isH1) {
        const innerContent =
            'logo' in item && item.logo && item.logo !== '' ? (
                <img className={styles.logo_image} src={item.logo} alt={this.getLogoAlt(item.title)} />
            ) : (
                <b className={styles.logo_text}>{item.title}</b>
            );

        return isH1 ? <h1 className={styles.logo_h1}>{innerContent}</h1> : innerContent;
    }

    // 显示其他导航；h1Index 为 h1 对应的 channel 下标
    otherNavRender(otherChannel = [], h1Index) {
        return otherChannel.map((item, index) => {
            const channelIndex = index + 2;
            const isH1 = channelIndex === h1Index;
            const inner = (
                <>
                    <span className={styles.logo_gt}>&gt;</span>
                    {item.title}
                </>
            );

            if (isH1) {
                return (
                    <h1 key={item.title} className={classnames(styles.logo_second_text, styles.logo_h1)}>
                        {inner}
                    </h1>
                );
            }

            return (
                <span key={item.title} className={styles.logo_second_text}>
                    {inner}
                </span>
            );
        });
    }

    render() {
        const { content } = this.props;
        const { channel = [], noAd, guanmingAd } = content;
        const [channel0, channel1, ...otherChannel] = channel;
        // 一级栏目 h1 在 logo；二级及以上 h1 在当前最深栏目
        const h1Index = channel.length === 1 ? 0 : channel.length - 1;

        return (
            <div className={classnames(styles.logo_box, 'clearfix')}>
                <div className={styles.logoBox2}>
                    {h1Index === 0 ? (
                        <h1 className={styles.logo_h1}>
                            <a href={`//${channel0.domain}`} target="_blank" rel="noopener noreferrer">
                                <img className={styles.logo_finace} src={formatUrl(channel[0].logo)} alt={this.getLogoAlt(channel[0].title)} />
                            </a>
                        </h1>
                    ) : (
                        <a href={`//${channel0.domain}`} target="_blank" rel="noopener noreferrer">
                            <img className={styles.logo_finace} src={formatUrl(channel[0].logo)} alt={this.getLogoAlt(channel[0].title)} />
                        </a>
                    )}
                    {channel.length === 1 && channel0.slogen && channel0.slogen !== '' ? (
                        <img className={styles.slogen} src={formatUrl(channel0.slogen)} />
                    ) : null}
                </div>
                {channel1 ? this.displayLogoOrTitleView(channel1, h1Index === 1) : null}
                {otherChannel && otherChannel.length > 0 ? this.otherNavRender(otherChannel, h1Index) : null}
                {!noAd && guanmingAd ? <Ad styleName={styles.ad} content={guanmingAd} /> : null}
                <Search content={content.search} />
            </div>
        );
    }
}

export { Logo };
export default Logo;
